import React from "react";

import { useTranslation } from "utils";

import { Button, Icon, SoilSightLoader, Typography } from "components";

export interface StaleOverlayProps {
  /** Covers the children. Callers keep it off the edit table, because the inputs must stay usable. */
  active: boolean;
  isRecalculating?: boolean;
  onRecalculate?: () => void | Promise<void>;
  children: React.ReactNode;
  dataTestId?: string;
}

export const StaleOverlay = ({ active, isRecalculating = false, onRecalculate, children, dataTestId = "detailed-calculations" }: StaleOverlayProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="detailed-calculations-stale-wrap">
      <div className={`detailed-calculations-scroll${active ? " detailed-calculations-scroll--dimmed" : ""}`} aria-hidden={active || undefined}>
        {children}
      </div>

      {active ? (
        <div className="detailed-calculations-stale-overlay" data-testid={`${dataTestId}-stale`} aria-busy={isRecalculating || undefined}>
          <div className="detailed-calculations-stale">
            {isRecalculating ? (
              <SoilSightLoader size="m" dataTestId={`${dataTestId}-stale-spin`} />
            ) : (
              <>
                <Icon iconName="tabler/loader" size="l" />
                <Typography variant="h5">{t("outcomeComparison.staleTitle")}</Typography>
                <Typography variant="paragraph-m" color="grey-600">
                  {t("outcomeComparison.staleBody")}
                </Typography>
                {onRecalculate ? (
                  <Button
                    type="primary"
                    size="middle"
                    icon={<Icon iconName="tabler/refresh" size="s" color="white" />}
                    iconLeft
                    onClick={onRecalculate}
                    dataTestId={`${dataTestId}-stale-recalculate`}
                  >
                    {t("outcomeComparison.updateForecast")}
                  </Button>
                ) : null}
              </>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default StaleOverlay;
